export class RequestWaterSamplingAddress {
    addressId: number;
    cityName: string;
    street: string;
    house: string;
    building: string;
    appartment: string;
    postCode: string;
}